{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartAppearanceEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.Forms, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCChart, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorListView, WEBLib.TMSFNCBitmapEditor
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit, FMX.SpinBox, FMX.Colors, FMX.Text, FMX.Edit, FMX.Layouts
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Samples.Spin
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Spin, ColorBox
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.ComCtrls
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  ,Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

  {$IFDEF VCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 5;
  MIDHEIGHTSPAC = 10;
  BIGHEIGHTSPAC = 15;
  {$ENDIF}
  {$IFDEF LCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF WEBLIB}
  CHECKBOXSIZE = 17;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 15;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF FMXLIB}
  CHECKBOXSIZE = 15;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  BIGDIV = 30;
  SMALLLBLSPACE = 10;
  MIDLBLSPACE = 20;
  BIGLBLSPACE = 30;
  SMALLHORSPACE = 60;
  MIDHORSPACE = 70;
  BIGHORSPACE = 80;
  SERIESLARGECONTROLWIDTH = 100;
  LARGECONTROLWIDTH = 100;
  SMALLCONTROLWIDTH = 45;
  VALUE_MBYES = 6;

resourcestring
  sTMSFNCChartAppearanceEditorOK = 'OK';
  sTMSFNCChartAppearanceEditorCancel = 'Cancel';
  sTMSFNCChartAppearanceEditorAppearance = 'Appearance';
  sTMSFNCChartAppearanceEditorSerieMargins = 'Series Margins';
  sTMSFNCChartAppearanceEditorLeft = 'Left';
  sTMSFNCChartAppearanceEditorTop = 'Top';
  sTMSFNCChartAppearanceEditorRight = 'Right';
  sTMSFNCChartAppearanceEditorBottom = 'Bottom';
  sTMSFNCChartAppearanceEditorCenter = 'Center';
  sTMSFNCChartAppearanceEditorFill = 'Fill';
  sTMSFNCChartAppearanceEditorStroke = 'Stroke';
  sTMSFNCChartAppearanceEditorColor = 'Color';
  sTMSFNCChartAppearanceEditorColorTo = 'Color To';
  sTMSFNCChartAppearanceEditorKind = 'Kind';
  sTMSFNCChartAppearanceEditorGradient = 'Gradient';
  sTMSFNCChartAppearanceEditorOpacity = 'Opacity';
  sTMSFNCChartAppearanceEditorWidth = 'Width';
  sTMSFNCChartAppearanceEditorPosition = 'Position';
  sTMSFNCChartAppearanceEditorInteraction = 'Interaction';
  sTMSFNCChartAppearanceEditorEnabled = 'Enabled';
  sTMSFNCChartAppearanceEditorPanning = 'Panning';
  sTMSFNCChartAppearanceEditorScaleMode = 'Scale Mode';
  sTMSFNCChartAppearanceEditorSample = 'Sample';
  sTMSFNCChartAppearanceEditorInitialize = '&Initialize';
  sTMSFNCChartAppearanceEditorInitText = 'Initializes the chart with 3 series and random data';

  sTMSFNCChartAppearanceEditorSaveChartMessage = 'Are you sure you want to save the changes made?';
  sTMSFNCChartAppearanceEditorCancelChartMessage = 'Are you sure you don''t want to save the changes made?';
  sTMSFNCChartAppearanceEditorClearSeriesMessage = 'Are you sure you want to clear the existing Series?';
type
  TTMSFNCChartAppearanceEditor = class;

  {$IFDEF FMXLIB}
  TTMSFNCChartAppearanceEditorParent = TFmxObject;
  TTMSFNCChartAppearanceEditorComboBox = class(TComboBox);
  TTMSFNCChartAppearanceEditorSpinEdit = class(TSpinBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  TTMSFNCChartAppearanceEditorColorCombo = class(TComboColorBox);
  TTMSFNCChartAppearanceEditorAlphaTrackBar = class(TAlphaTrackBar);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCChartAppearanceEditorParent = TWinControl;
  TTMSFNCChartAppearanceEditorComboBox = class(TComboBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  {$IFNDEF LCLLIB}
  TTMSFNCChartAppearanceEditorSpinEdit = class(TSpinEdit);
  {$ENDIF}
  {$IFDEF LCLLIB}
  TTMSFNCChartAppearanceEditorSpinEdit = class(TFloatSpinEdit);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCChartAppearanceEditorColorCombo = class(TColorBox);
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCChartAppearanceEditorColorCombo = class(TWebColorPicker);
  {$ENDIF}
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCChartAppearanceEditor = class(TTMSFNCCustomComponent)
  private
    FBitmapEditor: TTMSFNCBitmapEditor;
    {$IFNDEF FMXLIB}
    FVertScrlBox: TScrollBox;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FVertScrlBox: TVertScrollBox;
    {$ENDIF}
    FGeneralPanel: TTMSFNCEditorPanel;
    FBand1, FBand2, FBand3: TTMSFNCEditorPanel;

    FGenFillCol1, FGenFillCol2, FGenStrokeCol: TTMSFNCChartAppearanceEditorColorCombo;
    FGenEnabledCheck, FGenPanningCheck: TCheckBox;
    FGenFillKind, FGenFillGradient, FGenStrokeKind, FGenScaleMode: TTMSFNCChartAppearanceEditorComboBox;
    FGenAppLeft, FGenAppTop, FGenAppRight, FGenAppBottom, FGenStrokeWidth: TTMSFNCChartAppearanceEditorSpinEdit;
    {$IFDEF FMXLIB}
    FGenFillOpacity, FGenStrokeOpacity: TTMSFNCChartAppearanceEditorAlphaTrackBar;
    {$ENDIF}
    FButtonGenSample: TTMSFNCEditorButton;
    frm: TTMSFNCCustomDesignerForm;
    FPanel: TTMSFNCEditorPanel;
    FChart: TTMSFNCChart;
    FCopyChart: TTMSFNCChart;
    FButtonOk, FButtonCancel: TTMSFNCEditorButton;
    FModified: Boolean;
    procedure SetChart(const Value: TTMSFNCChart);
    function CancelChartMessage: Boolean;
    function SaveChartMessage: Boolean;
    function ClearSeriesMessage: Boolean;
    procedure SetBand1;
    procedure SetBand2;
    procedure SetBand3;
    procedure SetGeneralPanelHeight;
    function CalculateBand1Height: Single;
//    procedure CalculateBand1Size;
  protected
    {$IFDEF CMNWEBLIB}
    procedure SetColorComboStyle(AColorcombo: TTMSFNCChartAppearanceEditorColorCombo);
    {$ENDIF}
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure BuildEditor(AParent: TTMSFNCChartAppearanceEditorParent); virtual;
    procedure Initialize; virtual;
    procedure SetAppearance; virtual;
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure DoButtonSample(Sender: TObject); virtual;
    procedure DoGenAppSeriesChange(Sender: TObject); virtual;
    procedure DoGenAppFillChange(Sender: TObject); virtual;
    procedure DoGenAppStrokeChange(Sender: TObject); virtual;
    procedure DoGenInteractionChange(Sender: TObject); virtual;
    procedure CreateBottomPanel(AParent: TTMSFNCChartAppearanceEditorParent);
    {$IFDEF WEBLIB}
    procedure ApplyCSS(ACSS: string); virtual;
    {$ENDIF}
    function GetDocURL: string; override;
    function GetTipsURL: string; override;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Chart: TTMSFNCChart read FChart write SetChart;
  end;

  TTMSFNCChartAppearanceEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FChartEditor: TTMSFNCChartAppearanceEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AChartEditor: TTMSFNCChartAppearanceEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

  TTMSFNCChartAppearanceEditorDialog = class(TTMSFNCChartAppearanceEditor);

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.TMSFNCEditorsTools
  {$IFDEF FMXLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,WEBLib.Dialogs, VCL.Themes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,Dialogs
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.WebTools
  {$ENDIF}
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;
//{$R TMSFNCChartAppearanceEditor.res}
type
  TTMSFNCChartOpen = class(TTMSFNCChart);

{ TTMSFNCChartAppearanceEditor }

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

procedure TTMSFNCChartAppearanceEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FChart) then
    FChart := nil;
end;

procedure TTMSFNCChartAppearanceEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartAppearanceEditor);
end;

procedure TTMSFNCChartAppearanceEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCChartAppearanceEditor) then
    FChart := (Source as TTMSFNCChartAppearanceEditor).Chart;
end;

procedure TTMSFNCChartAppearanceEditor.BuildEditor(AParent: TTMSFNCChartAppearanceEditorParent);
begin
  if Assigned(AParent) then
  begin
    {$IFDEF FMXLIB}
    FVertScrlBox := TVertScrollBox.Create(AParent);
    FVertScrlBox.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FVertScrlBox := TScrollBox.Create(AParent);
    FVertScrlBox.Align := alClient;
    FVertScrlBox.Top := 0;
    {$IFDEF LCLLIB}
    FVertScrlBox.HorzScrollBar.Visible:= False;
    {$ENDIF}
    {$ENDIF}
    FVertScrlBox.Parent := AParent;
    {$IFDEF CMNWEBLIB}
    FVertScrlBox.BorderStyle := bsNone;
    if IsLightTheme then
      FVertScrlBox.Color := EDITORSUBBACKCOLORLIGHT
    else
      FVertScrlBox.Color := EDITORSUBBACKCOLORDARK;
    {$ENDIF}


    //                  General Panel
    //**************************************************

    FGeneralPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
    {$IFDEF FMXLIB}
    FGeneralPanel.Align := TAlignLayout.Top;
    FGeneralPanel.PanelPosition := eppBottom;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGeneralPanel.PanelPosition := eppCenter;
    FGeneralPanel.Align := alTop;
    FGeneralPanel.Top := 0;
    {$ENDIF}
    FGeneralPanel.Parent := FVertScrlBox;

    {$IFNDEF VCLLIB}
    SetBand1;
    SetBand2;
    SetBand3;
    {$ENDIF}
    {$IFDEF VCLLIB}
    SetBand3;
    SetBand2;
    SetBand1;
    {$ENDIF}
    SetGeneralPanelHeight;

    //                     Bottom Panel
    //-------------------------------------------------------
    CreateBottomPanel(AParent);

    Initialize;
    SetAppearance;
  end;
end;

procedure TTMSFNCChartAppearanceEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if SaveChartMessage then
    {$ENDIF}
      frm.ModalResult := mrOk;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrOk;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartAppearanceEditor.DoButtonSample(Sender: TObject);
begin
  if ClearSeriesMessage then
  begin
    FChart.InitSample;
    FModified := True;
  end;
end;

procedure TTMSFNCChartAppearanceEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if CancelChartMessage then
    {$ENDIF}
      frm.ModalResult := mrCancel;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrCancel;
    {$ENDIF}
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartAppearanceEditor.ApplyCSS(ACSS: string);
begin
//  FButtonOK.ElementClassName := 'IDEButton IDEFont';
//  FButtonCancel.ElementClassName := 'IDEButton IDEFont';
//  FButtonOpen.ElementClassName := 'IDEButton IDEFont';
//  FButtonClear.ElementClassName := 'IDEButton IDEFont';
//
//  FTopPanel.ElementClassName := 'IDEBkg';
//  FPanel.ElementClassName := 'IDEBkg';
end;
{$ENDIF}

function TTMSFNCChartAppearanceEditor.CalculateBand1Height: Single;
begin
  {$IFDEF FMXLIB}
  FBand1.Height := FGenAppBottom.Position.Y + FGenAppBottom.Height + 5;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FBand1.Height := FGenAppBottom.Top + FGenAppBottom.Height + 5;
  {$ENDIF}

  Result := FBand1.Height;
end;

function TTMSFNCChartAppearanceEditor.CancelChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartAppearanceEditorCancelChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

function TTMSFNCChartAppearanceEditor.ClearSeriesMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;

  res := TTMSFNCUtils.Message(sTMSFNCChartAppearanceEditorClearSeriesMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

constructor TTMSFNCChartAppearanceEditor.Create(AOwner: TComponent);
begin
  inherited;
  FBitmapEditor := TTMSFNCBitmapEditor.Create(Self);
end;

procedure TTMSFNCChartAppearanceEditor.CreateBottomPanel(AParent: TTMSFNCChartAppearanceEditorParent);
begin
  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Bottom;
  FPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alBottom;
  {$ENDIF}
  FPanel.Parent := AParent;

  FPanel.Height := 37;

  FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
//    FButtonCancel.ModalResult := mrCancel;
  FButtonCancel.Parent := FPanel;
  FButtonCancel.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorCancel);
  {$IFDEF FMXLIB}
  FButtonCancel.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonCancel.Align := alRight;
  FButtonCancel.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonCancel.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonCancel.BorderSpacing.Right := 5;
  FButtonCancel.BorderSpacing.Top := 5;
  FButtonCancel.BorderSpacing.Bottom := 5;
  FButtonCancel.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonCancel.Margins.Right := 5;
  FButtonCancel.Margins.Top := 5;
  FButtonCancel.Margins.Bottom := 5;
  FButtonCancel.Margins.Left := 5;
  {$ENDIF}
  FButtonCancel.OnClick := @DoButtonCancelClick;

  FButtonOK := TTMSFNCEditorButton.Create(FPanel);
//    FButtonOK.ModalResult := mrOk;
  FButtonOK.Parent := FPanel;
  FButtonOK.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorOK);
  {$IFDEF FMXLIB}
  FButtonOk.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonOk.Align := alRight;
  FButtonOk.Left := 98;
  {$IFDEF VCLWEBLIB}
  FButtonOK.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonOK.Margins.Right := 0;
  FButtonOK.Margins.Top := 5;
  FButtonOK.Margins.Bottom := 5;
  FButtonOK.Margins.Left := 5;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonOK.BorderSpacing.Right := 0;
  FButtonOK.BorderSpacing.Top := 5;
  FButtonOK.BorderSpacing.Bottom := 5;
  FButtonOK.BorderSpacing.Left := 5;
  {$ENDIF}
  FButtonOK.OnClick := @DoButtonOKClick;
end;

destructor TTMSFNCChartAppearanceEditor.Destroy;
begin
  FBitmapEditor.Free;
  inherited;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCChartAppearanceEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCChartAppearanceEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;

  if Key = KEY_ESCAPE then
    DoButtonCancelClick(Self)
  else if Key = KEY_RETURN then
    DoButtonOKClick(Self);
end;

procedure TTMSFNCChartAppearanceEditor.DoGenAppFillChange(Sender: TObject);
begin
  FChart.Fill.Kind := TTMSFNCGraphicsFillKind(FGenFillKind.ItemIndex);
  FChart.Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FGenFillGradient.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Fill.Color := FGenFillCol1.Color;
  FChart.Fill.ColorTo := FGenFillCol2.Color;
  FChart.Fill.Opacity := FGenFillOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Fill.Color := FGenFillCol1.Selected;
  FChart.Fill.ColorTo := FGenFillCol2.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartAppearanceEditor.DoGenAppSeriesChange(Sender: TObject);
begin
  FChart.SeriesMargins.Left := Round(FGenAppLeft.Value);
  FChart.SeriesMargins.Top := Round(FGenAppTop.Value);
  FChart.SeriesMargins.Right := Round(FGenAppRight.Value);
  FChart.SeriesMargins.Bottom := Round(FGenAppBottom.Value);

  FModified := True;
end;

procedure TTMSFNCChartAppearanceEditor.DoGenAppStrokeChange(Sender: TObject);
begin
  FChart.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FGenStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Stroke.Color := FGenStrokeCol.Color;
  FChart.Stroke.Opacity := FGenStrokeOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Stroke.Color := FGenStrokeCol.Selected;
  {$ENDIF}
  FChart.Stroke.Width := FGenStrokeWidth.Value;

  FModified := True;
end;

procedure TTMSFNCChartAppearanceEditor.DoGenInteractionChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Interaction :=  FGenEnabledCheck.IsChecked;
  FChart.InteractionOptions.Panning := FGenPanningCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Interaction :=  FGenEnabledCheck.Checked;
  FChart.InteractionOptions.Panning := FGenPanningCheck.Checked;
  {$ENDIF}
  FChart.InteractionOptions.ScaleMode := TTMSFNCChartInteractionScaleMode(FGenScaleMode.ItemIndex);

  FModified := True;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartAppearanceEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCChartAppearanceEditor.Execute: TModalResult;
{$ENDIF}
begin
  if not Assigned(Chart) then
  begin
    raise Exception.Create('No chart was assigned to the editor!');
    Exit;
  end;

  {$IFDEF WEBLIB}
  frm := TTMSFNCChartAppearanceEditorForm.CreateDialogNew(Self, 'Chart Appearance Editor');
  {$ELSE}
  frm := TTMSFNCChartAppearanceEditorForm.CreateNew(Application);
  frm.Caption := 'Chart Appearance Editor';
  frm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  {$ENDIF}

  FCopyChart := TTMSFNCChart.Create(frm);
  FCopyChart.Assign(Chart);

  frm.Width := 730;
  {$IFNDEF VCLLIB}
  frm.Height := 520;
  {$ENDIF}
  {$IFDEF VCLLIB}
  frm.Height := 580;
  {$ENDIF}
  {$IFDEF FMXLIB}
//  frm.Constraints.MinWidth := 260;
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  frm.OnKeyDown := DoFormKeyDown;
  {$ENDIF}
  {$IFDEF LCLLIB}
  frm.OnKeyDown := @DoFormKeyDown;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  frm.ActiveControl := FGeneralPanel;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) and Assigned(Chart) then
  begin
    Chart.Assign(nil);
    Chart.BeginUpdate;
    Chart.Assign(FCopyChart);
    Chart.EndUpdate;
    FCopyChart := nil;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) and Assigned(Chart) then
    begin
      Chart.Assign(nil);
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
      FCopyChart := nil;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

function TTMSFNCChartAppearanceEditor.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncchart';
end;

function TTMSFNCChartAppearanceEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCChartAppearanceEditor.GetTipsURL: string;
begin
  Result := 'https://www.tmssoftware.com/site/tmsfncchart.asp?s=faq';
end;

procedure TTMSFNCChartAppearanceEditor.Initialize;
begin
  //Values

  FGenAppLeft.Value := FChart.SeriesMargins.Left;
  FGenAppTop.Value := FChart.SeriesMargins.Top;
  FGenAppRight.Value := FChart.SeriesMargins.Right;
  FGenAppBottom.Value := FChart.SeriesMargins.Bottom;

  FGenFillKind.ItemIndex := Integer(FChart.Fill.Kind);
  FGenFillGradient.ItemIndex := Integer(FChart.Fill.GradientOrientation);
  {$IFDEF FMXLIB}
  FGenFillCol1.Color := FChart.Fill.Color;
  FGenFillCol2.Color := FChart.Fill.ColorTo;
  FGenFillOpacity.Value := FChart.Fill.Opacity;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenFillCol1.Selected := FChart.Fill.Color;
  FGenFillCol2.Selected := FChart.Fill.ColorTo;
  {$ENDIF}

  FGenStrokeKind.ItemIndex := Integer(FChart.Stroke.Kind);
  {$IFDEF FMXLIB}
  FGenStrokeCol.Color := FChart.Stroke.Color;
  FGenStrokeOpacity.Value := FChart.Stroke.Opacity;
  FGenStrokeWidth.Value := FChart.Stroke.Width;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenStrokeCol.Selected := FChart.Stroke.Color;
  FGenStrokeWidth.Value := Trunc(FChart.Stroke.Width);
  {$ENDIF}

  {$IFDEF FMXLIB}
  FGenEnabledCheck.IsChecked := FChart.Interaction;
  FGenPanningCheck.IsChecked := FChart.InteractionOptions.Panning;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenEnabledCheck.Checked := FChart.Interaction;
  FGenPanningCheck.Checked := FChart.InteractionOptions.Panning;
  {$ENDIF}
  FGenScaleMode.ItemIndex := Integer(FChart.InteractionOptions.ScaleMode);

  //Events
  FGenAppLeft.OnChange := @DoGenAppSeriesChange;
  FGenAppTop.OnChange := @DoGenAppSeriesChange;
  FGenAppRight.OnChange := @DoGenAppSeriesChange;
  FGenAppBottom.OnChange := @DoGenAppSeriesChange;

  {$IFDEF WEBLIB}
  FGenFillCol1.OnSelect := DoGenAppFillChange;
  FGenFillCol2.OnSelect := DoGenAppFillChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FGenFillCol1.OnChange := @DoGenAppFillChange;
  FGenFillCol2.OnChange := @DoGenAppFillChange;
  {$ENDIF}
  FGenFillKind.OnChange := @DoGenAppFillChange;
  FGenFillGradient.OnChange := @DoGenAppFillChange;

  {$IFDEF FMXLIB}
  FGenFillOpacity.OnChange := @DoGenAppFillChange;
  FGenStrokeOpacity.OnChange := @DoGenAppStrokeChange;
  {$ENDIF}

  FGenStrokeWidth.OnChange := @DoGenAppStrokeChange;
  FGenStrokeKind.OnChange := @DoGenAppStrokeChange;
  {$IFDEF WEBLIB}
  FGenStrokeCol.OnSelect := DoGenAppStrokeChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FGenStrokeCol.OnChange := @DoGenAppStrokeChange;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FGenEnabledCheck.OnChange := @DoGenInteractionChange;
  FGenPanningCheck.OnChange := @DoGenInteractionChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenEnabledCheck.OnClick := @DoGenInteractionChange;
  FGenPanningCheck.OnClick := @DoGenInteractionChange;
  {$ENDIF}
  FGenScaleMode.OnChange := @DoGenInteractionChange;
end;

function TTMSFNCChartAppearanceEditor.SaveChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartAppearanceEditorSaveChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartAppearanceEditor.SetAppearance;
var
  {$IFDEF VCLLIB}
  LDetails: TThemedElementDetails;
  clr: TTMSFNCGraphicsColor;
  {$ENDIF}
  okfntCol, fntCol, fillCol, primCol: TTMSFNCGraphicsColor;
  SubPanelFillCol, SubPanelStrokecol, MainPanelCol: TTMSFNCGraphicsColor;
begin
  primCol := EDITORPRIMCOLOR;
  fillCol := EDITORAUTOCOLOR;
  fntCol := EDITORAUTOCOLOR;
  okfntCol := EDITOROKFONTCOLOR;
  SubPanelStrokeCol := EDITORAUTOCOLOR;
  SubPanelFillCol := EDITORAUTOCOLOR;
  MainPanelCol := EDITORAUTOCOLOR;
  {$IFDEF VCLLIB}
  if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
  begin
    clr := StyleServices.GetStyleColor(scButtonHot);
    if clr <> clNone then
      primCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonPressed);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      okfntCol := clr;

//    LDetails := StyleServices.GetElementDetails(ttbButtonHot);
//    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
//    begin
//      fc := clr;
////      okfntCol := clr;
//    end;

    LDetails := StyleServices.GetElementDetails(ttbButtonNormal);

    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      fillCol := clr;

    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      fntCol := clr;

    LDetails := StyleServices.GetElementDetails(tpPanelBackground);
    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      SubPanelFillCol := clr;
    if StyleServices.GetElementColor(LDetails, ecBorderColor, clr) and (clr <> clNone) then
      SubPanelStrokeCol := clr;

    clr := StyleServices.GetSystemColor(clBtnFace);
    if (clr <> clNone) then
    begin
      MainPanelCol := clr;
    end;
  end;
  FButtonOk.StyleElements := FButtonOk.StyleElements - [seClient];
  FButtonCancel.StyleElements := FButtonCancel.StyleElements - [seClient];

  FGeneralPanel.StyleElements := FGeneralPanel.StyleElements - [seClient];
  FBand1.StyleElements := FBand1.StyleElements - [seClient];
  FBand2.StyleElements := FBand2.StyleElements - [seClient];
  FBand3.StyleElements := FBand3.StyleElements - [seClient];
  FPanel.StyleElements := FPanel.StyleElements - [seClient];
  {$ENDIF}

  SetEditorOKButtonAppearance(FButtonOk,primCol, EDITORBUTTONROUNDING, okfntCol);
  SetEditorCancelButtonAppearance(FButtonCancel, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);

  SetEditorSubPanelAppearance(FGeneralPanel, SubPanelFillCol, SubPanelStrokeCol);
    SetEditorSubPanelAppearance(FBand1, SubPanelFillCol, SubPanelStrokeCol);
    SetEditorSubPanelAppearance(FBand2, SubPanelFillCol, SubPanelStrokeCol);
    SetEditorSubPanelAppearance(FBand3, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorBackPanelAppearance(FPanel, MainPanelCol, MainPanelCol);
end;

procedure TTMSFNCChartAppearanceEditor.SetBand1;
var
  lbl1, lbl2, lbl3, lbl4, lbl5: TLabel;
begin
    FBand1 := TTMSFNCEditorPanel.Create(FGeneralPanel);
    {$IFDEF FMXLIB}
    FBand1.Align := TAlignLayout.Top;
    FBand1.PanelPosition := eppBottom;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FBand1.PanelPosition := eppCenter;
    FBand1.Align := alTop;
    FBand1.Top := 0;
    {$ENDIF}
    FBand1.Height := 150;
    FBand1.Parent := FGeneralPanel;

    lbl1 := TLabel.Create(FBand1);
    lbl1.Parent := FBand1;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := MIDLBLSPACE;
    lbl1.Position.Y := BIGHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorAppearance);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := MIDLBLSPACE;
    lbl1.Top := BIGHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorAppearance);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    lbl2 := TLabel.Create(FBand1);
    lbl2.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
    lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorSerieMargins);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl1.Left + SMALLHEIGHTSPAC;
    lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorSerieMargins);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FBand1);
    lbl3.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorLeft);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorLeft);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FGenAppLeft := TTMSFNCChartAppearanceEditorSpinEdit.Create(FBand1);
    FGenAppLeft.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenAppLeft.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FGenAppLeft.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenAppLeft.Height)/2;
    FGenAppLeft.ValueType := TNumValuetype.Float;
    FGenAppLeft.DecimalDigits := 1;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenAppLeft.Left := lbl3.Left + SMALLHORSPACE;
    FGenAppLeft.Top := lbl3.Top + (lbl3.Height - FGenAppLeft.Height) div 2;
    {$ENDIF}
    FGenAppLeft.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FBand1);
    lbl4.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorTop);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorTop);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FGenAppTop := TTMSFNCChartAppearanceEditorSpinEdit.Create(FBand1);
    FGenAppTop.Parent := FBand1;

    {$IFDEF FMXLIB}
    FGenAppTop.Position.X := FGenAppLeft.Position.X;
    FGenAppTop.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenAppTop.Height)/2;
    FGenAppTop.ValueType := TNumValuetype.Float;
    FGenAppTop.DecimalDigits := 1;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenAppTop.Left := FGenAppLeft.Left;
    FGenAppTop.Top := lbl4.Top + (lbl4.Height - FGenAppTop.Height) div 2;
    {$ENDIF}
    FGenAppTop.Width := LARGECONTROLWIDTH;

    lbl3 := TLabel.Create(FBand1);
    lbl3.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorRight);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorRight);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FGenAppRight := TTMSFNCChartAppearanceEditorSpinEdit.Create(FBand1);
    FGenAppRight.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenAppRight.DecimalDigits := 1;
    FGenAppRight.Position.X := FGenAppLeft.Position.X;
    FGenAppRight.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenAppLeft.Height)/2;
    FGenAppRight.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenAppRight.Left := FGenAppLeft.Left;
    FGenAppRight.Top := lbl3.Top + (lbl3.Height - FGenAppLeft.Height) div 2;
    {$ENDIF}
    FGenAppRight.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FBand1);
    lbl4.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorBottom);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorBottom);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FGenAppBottom := TTMSFNCChartAppearanceEditorSpinEdit.Create(FBand1);
    FGenAppBottom.Parent := FBand1;

    {$IFDEF FMXLIB}
    FGenAppBottom.Position.X := FGenAppLeft.Position.X;
    FGenAppBottom.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenAppTop.Height)/2;
    FGenAppBottom.ValueType := TNumValuetype.Float;
    FGenAppBottom.DecimalDigits := 1;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenAppBottom.Left := FGenAppLeft.Left;
    FGenAppBottom.Top := lbl4.Top + (lbl4.Height - FGenAppTop.Height) div 2;
    {$ENDIF}
    FGenAppBottom.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    FBand1.Width := FGenAppBottom.Position.X + FGenAppBottom.Width + 5;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FBand1.Width := FGenAppBottom.Left + FGenAppBottom.Width + 5;
    {$ENDIF}

    lbl3 := TLabel.Create(FBand1);
    lbl3.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl3.Position.X := FGenAppBottom.Position.X + FGenAppBottom.Width + BIGDIV;
    lbl3.Position.Y := lbl2.Position.Y;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorFill);
    lbl3.StyledSettings := lbl3.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := FGenAppBottom.Left + FGenAppBottom.Width + BIGDIV;
    lbl3.Top := lbl2.Top;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorFill);
    {$ENDIF}
    lbl3.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl3);

    lbl2 := TLabel.Create(FBand1);
    lbl2.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl3.Position.X + MIDLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl3.Left + MIDLBLSPACE;
    lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl2);

    FGenFillCol1 := TTMSFNCChartAppearanceEditorColorCombo.Create(FBand1);
    FGenFillCol1.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenFillCol1.Position.X := lbl2.Position.X + SMALLHORSPACE;
    FGenFillCol1.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenFillCol1.Height)/2;
    FGenFillCol1.Width := SMALLCONTROLWIDTH;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FGenFillCol1);
    FGenFillCol1.Width := LARGECONTROLWIDTH;
    FGenFillCol1.Left := lbl2.Left + SMALLHORSPACE;
    FGenFillCol1.Top := lbl2.Top + (lbl2.Height - FGenFillCol1.Height) div 2;
    {$ENDIF}

    {$IFDEF CMNWEBLIB}
    lbl5 := TLabel.Create(FBand1);
    lbl5.Parent := FBand1;
    lbl5.Left := lbl2.Left;
    lbl5.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
    lbl5.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorColorTo);
    SetEditorLabelAppearance(lbl5);
    {$ENDIF}

    FGenFillCol2 := TTMSFNCChartAppearanceEditorColorCombo.Create(FBand1);
    FGenFillCol2.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenFillCol2.Position.X := FGenFillCol1.Position.X + FGenFillCol1.Width + SMALLLBLSPACE;
    FGenFillCol2.Position.Y := FGenFillCol1.Position.Y;
    FGenFillCol2.Width := SMALLCONTROLWIDTH;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FGenFillCol2);
    FGenFillCol2.Width := FGenFillCol1.Width;
    FGenFillCol2.Left := FGenFillCol1.Left;
    FGenFillCol2.Top := lbl5.Top + (lbl5.Height - FGenFillCol2.Height) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FBand1);
    lbl4.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl2.Position.X;
    lbl4.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl5.Left;
    lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FGenFillKind := TTMSFNCChartAppearanceEditorComboBox.Create(FBand1);
    FGenFillKind.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenFillKind.Position.X := FGenFillCol1.Position.X;
    FGenFillKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenFillKind.Height)/2;
//    FGenFillKind.ReadOnly := True;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenFillKind.Left := FGenFillCol1.Left;
    FGenFillKind.Top := lbl4.Top + (lbl4.Height - FGenFillKind.Height) div 2;
    {$ENDIF}
    FGenFillKind.Items.Add('None');
    FGenFillKind.Items.Add('Solid');
    FGenFillKind.Items.Add('Gradient');
    FGenFillKind.Width := LARGECONTROLWIDTH;

    lbl5 := TLabel.Create(FBand1);
    lbl5.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl5.Position.X := lbl4.Position.X;
    lbl5.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl5.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorGradient);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl5.Left := lbl4.Left;
    lbl5.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl5.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorGradient);
    {$ENDIF}
    SetEditorLabelAppearance(lbl5);

    FGenFillGradient := TTMSFNCChartAppearanceEditorComboBox.Create(FBand1);
    FGenFillGradient.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenFillGradient.Position.X := FGenFillCol1.Position.X;
    FGenFillGradient.Position.Y := lbl5.Position.Y + (lbl5.Height - FGenFillGradient.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenFillGradient.Left := FGenFillCol1.Left;
    FGenFillGradient.Top := lbl5.Top + (lbl5.Height - FGenFillGradient.Height) div 2;
    {$ENDIF}
    FGenFillGradient.Items.Add('Horizontal');
    FGenFillGradient.Items.Add('Vertical');
    FGenFillGradient.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FBand1);
    lbl2.Parent := FBand1;
    lbl2.Position.X := lbl5.Position.X;
    lbl2.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorOpacity);

    SetEditorLabelAppearance(lbl2);

    FGenFillOpacity := TTMSFNCChartAppearanceEditorAlphaTrackBar.Create(FBand1);
    FGenFillOpacity.Parent := FBand1;
    FGenFillOpacity.Position.X := FGenFillKind.Position.X;
    FGenFillOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenFillOpacity.Height)/2;
    FGenFillOpacity.Width := LARGECONTROLWIDTH;
    {$ENDIF}

    lbl2 := TLabel.Create(FBand1);
    lbl2.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl2.Position.X := FGenFillKind.Position.X + FGenFillKind.Width + BIGDIV;
    lbl2.Position.Y := lbl3.Position.Y;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorStroke);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := FGenFillKind.Left + FGenFillKind.Width + BIGDIV;
    lbl2.Top := lbl3.Top;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorStroke);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FBand1);
    lbl3.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FGenStrokeCol := TTMSFNCChartAppearanceEditorColorCombo.Create(FBand1);
    FGenStrokeCol.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FGenStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenStrokeCol.Height)/2;
    FGenStrokeCol.Width := LARGECONTROLWIDTH;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FGenStrokeCol);
    FGenStrokeCol.Width := LARGECONTROLWIDTH;
    FGenStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
    FGenStrokeCol.Top := lbl3.Top + (lbl3.Height - FGenStrokeCol.Height) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FBand1);
    lbl4.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FGenStrokeKind := TTMSFNCChartAppearanceEditorComboBox.Create(FBand1);
    FGenStrokeKind.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenStrokeKind.Position.X := FGenStrokeCol.Position.X;
    FGenStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenStrokeKind.Height)/2;
//    FGenStrokeKind.ReadOnly := True;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenStrokeKind.Left := FGenStrokeCol.Left;
    FGenStrokeKind.Top := lbl4.Top + (lbl4.Height - FGenStrokeKind.Height) div 2;
    {$ENDIF}
    FGenStrokeKind.Items.Add('None');
    FGenStrokeKind.Items.Add('Solid');
    FGenStrokeKind.Items.Add('Dash');
    FGenStrokeKind.Items.Add('Dot');
    FGenStrokeKind.Items.Add('DashDot');
    FGenStrokeKind.Items.Add('DashDotDot');
    FGenStrokeKind.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FBand1);
    lbl2.Parent := FBand1;
    lbl2.Position.X := lbl4.Position.X;
    lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorOpacity);
    SetEditorLabelAppearance(lbl2);

    FGenStrokeOpacity := TTMSFNCChartAppearanceEditorAlphaTrackBar.Create(FBand1);
    FGenStrokeOpacity.Parent := FBand1;
    FGenStrokeOpacity.Position.X := FGenStrokeKind.Position.X;
    FGenStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenStrokeOpacity.Height)/2;
    FGenStrokeOpacity.Width := LARGECONTROLWIDTH;
    {$ENDIF}

    lbl3 := TLabel.Create(FBand1);
    lbl3.Parent := FBand1;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorWidth);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorWidth);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FGenStrokeWidth := TTMSFNCChartAppearanceEditorSpinEdit.Create(FBand1);
    FGenStrokeWidth.Parent := FBand1;
    {$IFDEF FMXLIB}
    FGenStrokeWidth.Min := 0;
    FGenStrokeWidth.DecimalDigits := 1;
    FGenStrokeWidth.Position.X := FGenStrokeOpacity.Position.X;
    FGenStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenAppLeft.Height)/2;
    FGenStrokeWidth.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenStrokeWidth.MinValue := 0;
    FGenStrokeWidth.Left := FGenStrokeCol.Left;
    FGenStrokeWidth.Top := lbl3.Top + (lbl3.Height - FGenAppLeft.Height) div 2;
    {$ENDIF}
    FGenStrokeWidth.Width := LARGECONTROLWIDTH;
end;

procedure TTMSFNCChartAppearanceEditor.SetBand2;
var
  lbl1, lbl3, lbl4: TLabel;
begin
    FBand2 := TTMSFNCEditorPanel.Create(FGeneralPanel);
    {$IFDEF FMXLIB}
    FBand2.Align := TAlignLayout.Top;
    FBand2.PanelPosition := eppBottom;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FBand2.PanelPosition := eppCenter;
    FBand2.Align := alTop;
    FBand2.Top := 0;
    {$ENDIF}
    FBand2.Height := 150;
    FBand2.Parent := FGeneralPanel;

    lbl1 := TLabel.Create(FBand2);
    lbl1.Parent := FBand2;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := MIDLBLSPACE;
    lbl1.Position.Y := BIGHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorInteraction);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := MIDLBLSPACE;
    lbl1.Top := BIGHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorInteraction);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    lbl3 := TLabel.Create(FBand2);
    lbl3.Parent := FBand2;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl1.Position.X + BIGLBLSPACE;
    lbl3.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorEnabled);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl1.Left + BIGLBLSPACE;
    lbl3.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorEnabled);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FGenEnabledCheck := TCheckBox.Create(FBand2);
    FGenEnabledCheck.Parent := FBand2;
    {$IFDEF FMXLIB}
    FGenEnabledCheck.Position.X := lbl3.Position.X + BIGHORSPACE;
    FGenEnabledCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenEnabledCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenEnabledCheck.Height := CHECKBOXSIZE;
    FGenEnabledCheck.Width := CHECKBOXSIZE;
    FGenEnabledCheck.Left := lbl3.Left + BIGHORSPACE;
    FGenEnabledCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FBand2);
    lbl4.Parent := FBand2;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorPanning);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorPanning);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FGenPanningCheck := TCheckBox.Create(FBand2);
    FGenPanningCheck.Parent := FBand2;
    {$IFDEF FMXLIB}
    FGenPanningCheck.Position.X := FGenEnabledCheck.Position.X;
    FGenPanningCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenPanningCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenPanningCheck.Height := CHECKBOXSIZE;
    FGenPanningCheck.Width := CHECKBOXSIZE;
    FGenPanningCheck.Left := FGenEnabledCheck.Left;
    FGenPanningCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl3 := TLabel.Create(FBand2);
    lbl3.Parent := FBand2;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorScaleMode);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorScaleMode);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FGenScaleMode := TTMSFNCChartAppearanceEditorComboBox.Create(FBand2);
    FGenScaleMode.Parent := FBand2;
    {$IFDEF FMXLIB}
    FGenScaleMode.Position.X := FGenEnabledCheck.Position.X;
    FGenScaleMode.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenScaleMode.Height)/2;
//    FGenScaleMode.ReadOnly := True;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGenScaleMode.Left := FGenEnabledCheck.Left;
    FGenScaleMode.Top := lbl3.Top + (lbl3.Height - FGenScaleMode.Height) div 2;
    {$ENDIF}
    FGenScaleMode.Items.Add('None');
    FGenScaleMode.Items.Add('Horizontal');
    FGenScaleMode.Items.Add('Vertical');
    FGenScaleMode.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    FBand2.Height := FGenScaleMode.Position.Y + FGenScaleMode.Height + 5;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FBand2.Height := FGenScaleMode.Top + FGenScaleMode.Height + 5;
    {$ENDIF}
end;

procedure TTMSFNCChartAppearanceEditor.SetBand3;
var
  lbl1, lbl3: TLabel;
begin
    FBand3 := TTMSFNCEditorPanel.Create(FGeneralPanel);
    {$IFDEF FMXLIB}
    FBand3.Align := TAlignLayout.Top;
    FBand3.PanelPosition := eppBottom;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FBand3.PanelPosition := eppCenter;
    FBand3.Align := alTop;
    FBand3.Top := 0;
    {$ENDIF}
    FBand3.Height := 150;
    FBand3.Parent := FGeneralPanel;

    lbl1 := TLabel.Create(FBand3);
    lbl1.Parent := FBand3;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := MIDLBLSPACE;
    lbl1.Position.Y := BIGHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorSample);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := MIDLBLSPACE;
    lbl1.Top := BIGHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorSample);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    FButtonGenSample := TTMSFNCEditorButton.Create(FBand3);
    FButtonGenSample.Parent := FBand3;
    FButtonGenSample.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorInitialize);
    {$IFDEF FMXLIB}
    FButtonGenSample.Position.X := lbl1.Position.X + BIGLBLSPACE;
    FButtonGenSample.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FButtonGenSample.Left := lbl1.Left + BIGLBLSPACE;
    FButtonGenSample.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    FButtonGenSample.Width := MIDHORSPACE;
    FButtonGenSample.OnClick := @DoButtonSample;
    SetEditorIconButtonAppearance(FButtonGenSample);

    lbl3 := TLabel.Create(FBand3);
    lbl3.Parent := FBand3;
    {$IFDEF FMXLIB}
    lbl3.Position.X := FButtonGenSample.Position.X + FButtonGenSample.Width + SMALLLBLSPACE;
    lbl3.Position.Y := FButtonGenSample.Position.Y + (FButtonGenSample.Height - lbl3.Height)/2;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAppearanceEditorInitText);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := FButtonGenSample.Left + FButtonGenSample.Width + SMALLLBLSPACE;
    lbl3.Top := FButtonGenSample.Top + (FButtonGenSample.Height - lbl3.Height) div 2;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAppearanceEditorInitText);
    {$ENDIF}
    lbl3.Width := 300;
    SetEditorLabelAppearance(lbl3);

    {$IFDEF FMXLIB}
    FBand3.Height := FButtonGenSample.Position.Y + FButtonGenSample.Height + 5;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FBand3.Height := FButtonGenSample.Top + FButtonGenSample.Height + 5;
    {$ENDIF}
end;

procedure TTMSFNCChartAppearanceEditor.SetChart(const Value: TTMSFNCChart);
begin
  FChart := Value;
end;

procedure TTMSFNCChartAppearanceEditor.SetGeneralPanelHeight;
var
  h: Single;
begin
  if Assigned(FGeneralPanel) then
  begin
    h := 0;

    if Assigned(FBand1) then
      h := CalculateBand1Height;
    if Assigned(FBand2) then
      h := h + FBand2.Height;
    if Assigned(FBand3) then
      h := h + FBand3.Height;

    FGeneralPanel.Height := Trunc(h) + 1;
  end;
end;

{$IFDEF FMXLIB}
{ TTMSFNCChartAppearanceEditorSpinEdit }

constructor TTMSFNCChartAppearanceEditorSpinEdit.Create(AOwner: TComponent);
begin
  inherited;
  Max := 100000;
  Min := -100000;
end;
{$ENDIF}

{$IFDEF CMNWEBLIB}
constructor TTMSFNCChartAppearanceEditorComboBox.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF VCLLIB}
  {$IF COMPILERVERSION > 34}
  AutoDropDownWidth := True;
  {$IFEND}
  {$ENDIF}
end;

procedure TTMSFNCChartAppearanceEditor.SetColorComboStyle(AColorcombo: TTMSFNCChartAppearanceEditorColorCombo);
begin
  {$IFNDEF WEBLIB}
  AColorcombo.Style := [cbStandardColors, cbExtendedColors, cbCustomColor];
  {$ENDIF}
end;
{$ENDIF}

{$IFDEF WEBLIB}

{ TTMSFNCChartAppearanceEditorForm }

constructor TTMSFNCChartAppearanceEditorForm.CreateDialogNew(AChartEditor: TTMSFNCChartAppearanceEditor; ACaption: string);
begin
  FChartEditor := AChartEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCChartAppearanceEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FChartEditor) then
  begin
    FChartEditor.BuildEditor(Self);
  end;
end;

procedure TTMSFNCChartAppearanceEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    if Assigned(FChartEditor) then
      FChartEditor.ApplyCSS(css);
  end;
end;
{$ENDIF}

end.
